import { getSrcs, imageUrl } from '@helpers/image';
import { highlightTitleWords } from '@helpers/utils';
import { videoUrl } from '@helpers/video';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import { m, useReducedMotion } from 'framer-motion';
import * as React from 'react';
import S from './BannerItem.styles';
const BannerItem = (props) => {
    const reduceMotion = useReducedMotion();
    const refVideo = React.useRef(null);
    const srcs = props.image ? getSrcs(props.image, 2650, 375, 10, props.site) : [];
    React.useEffect(() => {
        if (!refVideo.current) {
            return;
        }
        if (props.active && props.shouldPlay) {
            refVideo.current.currentTime = 0;
            refVideo.current.play();
        }
        else {
            refVideo.current.pause();
        }
    }, [props.active, props.shouldPlay]);
    return (React.createElement(S.Container, { "aria-current": props.active === 'active', initial: props.index === 0 ? 'initial' : 'after', animate: props.active, variants: {
            before: {
                transition: {
                    when: 'afterChildren',
                },
                transitionEnd: {
                    display: 'none',
                },
            },
            after: {
                transition: {
                    when: 'afterChildren',
                },
                transitionEnd: {
                    display: 'none',
                },
            },
            active: {
                display: 'grid',
            },
        }, style: { '--tintAmount': props.tint } },
        React.createElement(S.MediaWrapper, { variants: {
                before: {
                    opacity: 1,
                    zIndex: 0,
                    y: reduceMotion ? 0 : -150,
                    transitionEnd: {
                        opacity: 0,
                    },
                },
                after: {
                    opacity: 1,
                    zIndex: 0,
                    y: reduceMotion ? 0 : 150,
                    transitionEnd: {
                        opacity: 0,
                    },
                },
                active: {
                    opacity: 1,
                    zIndex: 1,
                    y: 0,
                },
            }, transition: {
                duration: 0.5,
                ease: 'easeOut',
            } },
            props.image && (React.createElement(S.Image, { alt: props.image.altText, draggable: false, loading: props.index === 0 ? 'eager' : 'lazy', role: "presentation", src: srcs[0].split(' ')[0], srcSet: srcs.join(','), "data-mobile-only": !!props.video })),
            props.video && (React.createElement(S.Video, { ref: refVideo, muted: true, playsInline: true, preload: "none", loop: true, poster: props.image
                    ? imageUrl(props.image, {}, props.site)
                    : videoUrl(props.video, { format: 'jpg' }, props.site), "data-hide-mobile": !!props.image },
                React.createElement("source", { type: "video/webm", src: videoUrl(props.video, { format: 'webm' }, props.site) }),
                React.createElement("source", { type: "video/mp4", src: videoUrl(props.video, { format: 'mp4' }, props.site) })))),
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, { variants: {
                    before: {},
                    after: {},
                    active: {
                        transition: {
                            delayChildren: reduceMotion ? 0 : 0.5,
                            staggerChildren: reduceMotion ? 0 : 0.15,
                        },
                    },
                } },
                React.createElement(S.Title, { as: props.index === 0 ? m.h1 : m.h2, variants: {
                        initial: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        after: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        before: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        active: {
                            opacity: 1,
                            x: 0,
                        },
                    }, transition: {
                        duration: 0.5,
                        ease: 'easeOut',
                    }, dangerouslySetInnerHTML: { __html: highlightTitleWords(props.title) } }),
                props.content && (React.createElement(S.Content, { variants: {
                        initial: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        after: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        before: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        active: {
                            opacity: 1,
                            x: 0,
                        },
                    }, transition: {
                        duration: 0.5,
                        ease: 'easeOut',
                    }, dangerouslySetInnerHTML: { __html: props.content } })),
                props.cta && (React.createElement(S.CtaWrapper, { variants: {
                        initial: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        after: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        before: {
                            opacity: 0,
                            x: reduceMotion ? 0 : -20,
                        },
                        active: {
                            opacity: 1,
                            x: 0,
                        },
                    }, transition: {
                        duration: 0.5,
                        ease: 'easeOut',
                    } },
                    React.createElement(LinkButton, { buttonType: "default", href: props.cta.url, target: props.cta.target, site: props.site }, props.cta.text)))))));
};
export default BannerItem;
